import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';
import { POSITION_CLASSES } from '../../utils';

const CenteredSpinner = ({ label = 'Please wait...', position = "center" }) => (
  <div className={POSITION_CLASSES[position]}>
    <Box
      className="leaflet-control"
      pos="absolute"
      zIndex="docked"
      top="0"
      bottom="0"
      left="0"
      right="0"
      d="block"
    >
      <Spinner
        size="xl"
        ml="-4"
        thickness="5px"
        color="brand.red.800"
        speed="0.65s"
        label={label}
      />
    </Box>
  </div>
);

export default CenteredSpinner;
